import React, { useEffect, useRef, useState } from 'react'
import { Input, Button, Toast } from '@ow/comps'
import { pick, findKey, cloneDeep } from 'lodash-es'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import useAreaStore from '../areaStore'
import nulldata from '../assets/nulldata.png'
import BindList from './bindList'
import { useBindLevel } from './utils'

const bindTypeConfig = {
  user: '用户',
  standard: '指标',
}

const bindLimit = {
  isFirstLevel: '一级',
  isLastLevel: '末级',
}

/**
 * 新建绑定用户页面
 * @returns
 */
const Create = function ({ desc }) {
  const [ruleName, setRuleName] = useState('默认规则')
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const {
    setAreaState,
    setBindedList,
    clearBindedUserMap,
    areaBindType,
    ruleId,
    ruleName: name,
    bindedIdsMap,
    objectIdsBindedList,
  } = useAreaStore((state) =>
    pick(state, [
      'setAreaState',
      'setBindedList',
      'clearBindedUserMap',
      'areaBindType',
      'ruleId',
      'ruleName',
      'bindedIdsMap',
      'objectIdsBindedList',
    ])
  )
  const { clickedInfo, ditto, setClickedInfo, setSelectedIds } = useTbViewStore(
    (state) =>
      pick(state, ['clickedInfo', 'ditto', 'setClickedInfo', 'setSelectedIds'])
  )

  const { tbs, getDitto } = useAppEx((state) =>
    pick(state, ['tbs', 'getDitto'])
  )

  const ruleIdsRef = useRef({})

  const levelType = useBindLevel(areaBindType)
  const canMulti = levelType === 'isLastLevel'

  const { clickedId = null } = clickedInfo
  const level = clickedInfo[levelType] || false

  const cancel = () => {
    setAreaState({ isCreateAreaBind: false, ruleId: null })
    clearBindedUserMap()
    setSelectedIds([])
    setClickedInfo({})
  }

  const createRule = async () => {
    let res
    setSaving(true)
    if (areaBindType === 'user') {
      const bindTb = findKey(tbs, (tb) => {
        return tb.extend.areaBindUser
      })

      res = await ditto.createBindUserRule({
        ruleId,
        ruleName,
        targetTbId: bindTb,
        ruleConfig: bindedIdsMap,
      })
    } else if (areaBindType === 'standard') {
      const standardTbId = getDitto('standard').tbId

      res = await ditto.createBindRule({
        ruleId,
        ruleName,
        targetTbId: standardTbId,
        ruleConfig: bindedIdsMap,
        ruleIds: cloneDeep(ruleIdsRef.current),
      })
    }

    setSaving(false)
    if (res.success) {
      Toast.success({ title: res.message })
      cancel()
    } else {
      Toast.error({ title: res.message })
    }
  }

  useEffect(() => {
    if (!ruleId) return
    if (areaBindType === 'user') {
      ditto.fetchRuleObjectList(ruleId).then((res) => {
        setAreaState({ objectIdsBindedList: res })
      })
    } else if (areaBindType === 'standard') {
      ditto.fetchBindNodeRuleList(ruleId).then((res) => {
        const ruleConfig = {}
        res.forEach((item) => {
          if (ruleConfig[item.leaderBindId]) {
            ruleConfig[item.leaderBindId].push(item.followerBindId)
            ruleIdsRef.current[item.leaderBindId][item.followerBindId] = item.id
          } else {
            ruleConfig[item.leaderBindId] = [item.followerBindId]
            ruleIdsRef.current[item.leaderBindId] = {
              [item.followerBindId]: item.id,
            }
          }
        })

        setAreaState({
          bindedIdsMap: ruleConfig,
          objectIdsBindedList: Object.keys(ruleConfig),
        })
      })
    }
  }, [ruleId, areaBindType])

  useEffect(() => {
    if (
      !ruleId ||
      !objectIdsBindedList.includes(clickedId) ||
      bindedIdsMap[clickedId]
    )
      return
    setLoading(true)
    ditto
      .fetchRuleObjectUserList(ruleId, clickedId)
      .then((res) => {
        setBindedList(clickedId, res)
      })
      .catch(() => {
        Toast.error({ title: '获取用户信息失败' })
      })
      .finally(() => {
        setLoading(false)
      })
  }, [ruleId, clickedId, bindedIdsMap, objectIdsBindedList])

  return (
    <div className="flex flex-col gap-2 flex-1 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 bg-white">
        <div className="flex gap-4 items-center text-sm">
          <div className="whitespace-nowrap">规则名称</div>
          {ruleId ? (
            <div>{name}</div>
          ) : (
            <Input
              value={ruleName}
              style={{ width: '400px' }}
              placeholder="请输入规则名称"
              onChange={(e) => {
                setRuleName(e.target.value)
              }}
            />
          )}
        </div>
        <div className="flex gap-3">
          <Button type="primary" onClick={createRule} loading={saving}>
            保存
          </Button>
          <Button stroke onClick={cancel}>
            返回
          </Button>
        </div>
      </div>
      <div className="p-4 bg-white flex-1 overflow-hidden">
        {!level || !clickedId ? (
          <div className="flex items-center justify-center">
            <div className="flex flex-col gap-8">
              <img
                src={nulldata}
                alt="nulldata"
                style={{ width: '300px', height: '260px' }}
              />
              <div className="text-sm text-center text-neutral-1000">
                选中{bindLimit[levelType]}
                {desc}后，可对{desc}进行绑定
                {bindTypeConfig[areaBindType]}
                操作。
                <br />
                {canMulti && (
                  <span>
                    或者勾选多个{desc}后，点击【批量绑定】进行批量操作
                  </span>
                )}
              </div>
            </div>
          </div>
        ) : (
          <BindList loading={loading} bindInfo={bindTypeConfig[areaBindType]} />
        )}
      </div>
    </div>
  )
}

export default Create
